import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './style.scss';

const Testimonial = (props) => {
  const [page, setPage] = useState(0);
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const testimonialsRef = React.createRef();

  function scrollToPage(p) {
    if(p < 0) {
      p = testimonials.length - 1;
    } else if(p >= testimonials.length) {
      p = 0;
    }

    setPage(p);
    if (testimonialsRef.current) {
      testimonialsRef.current.scrollTo({
        left: testimonialsRef.current.clientWidth * p,
        behavior: 'smooth'
      });
    }
  }

  useEffect(() => {
    // Fetch testimonials from the API
    setLoading(true);
    
    // Get the current URL path
    const url = window.location.pathname;
    
    fetch(`https://nsbackend.campaigns.fi/testimonials/public?url=${encodeURIComponent(url)}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        setTestimonials(data);
        setLoading(false);
        setError(null);
      })
      .catch(error => {
        console.error('Error loading testimonials:', error);
        setError('Failed to load testimonials');
        setLoading(false);
      });
  }, [props.location]);

  if (loading) {
    return <div className="loading">Loading testimonials...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  if (testimonials.length === 0) {
    return null;
  }

  return (
    <Container className="p-t-50 text-center">
      <Row>
        <Col>
          <h3 className="testimonial-header">Mitä asiakkaat sanovat meistä:</h3>

          <div className="testimonial-carousel">
            <div className={"arrow left" + (page === 0 ? ' disabled' : '')} onClick={() => {scrollToPage(page - 1)}}>&#10094;</div>
            <div className={"arrow right" + (page === testimonials.length - 1 ? ' disabled' : '')} onClick={() => {scrollToPage(page + 1)}}>&#10095;</div>

            <div className="testimonials" ref={testimonialsRef}>
              {testimonials.map((testimonial, index) => {
                return <div className="testimonial" key={index}>
                  <span className="image" style={{backgroundImage: testimonial.image ? `url(${testimonial.image})` : 'none'}}><br/><br/></span>
                  <div className="quote">
                    {testimonial.text}
                  </div>

                  <div className="name">
                    {testimonial.name}
                  </div>

                  <div className="title">
                    {testimonial.title}
                  </div>
                </div>
              })}
            </div>

            <div className="testimonial-carousel-dots">
              {testimonials.map((testimonial, index) => {
                return <span className={"dot " + (page === index ? 'active' : '')} key={index} onClick={() => {scrollToPage(index)}}></span>
              })}
            </div>

            <a className="btn-grey" href="#">PYYDÄ TARJOUS</a>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Testimonial;
